import { FC, useEffect, useState } from 'react';
import { Form, Select } from 'antd';
import { FormContentLayout } from '../FormContentLayout';
import { ButtonPair } from '../ButtonPair';

// import 'antd/dist/antd.css';
import styles from './index.module.css';
import { EddLayout } from '../EddLayout';
import { EddSteps, PROCESSING_TIME_FORM_NAME } from '../../constants';

const PROCESSING_TIME_TITLE = 'How quickly do you ship out orders?';
const PROCESSING_TIME_DESCRIPTION = 'Orders placed after 12pm (PT) will be processed the next business day.';

interface ProcessingTimeProps {
  timeOptions: string[];
}

const ProcessingTime: FC<ProcessingTimeProps> = ({ timeOptions }) => {
  const form = Form.useFormInstance();
  const selectOptions = timeOptions.map((item) => ({ value: item }));
  const initialValue = selectOptions?.[0].value;
  const existedFormValue = form.getFieldValue(PROCESSING_TIME_FORM_NAME);
  const [value, setValue] = useState(existedFormValue || initialValue);
  const handleValueChange = (data: string) => {
    setValue(data);
    form.setFieldValue(PROCESSING_TIME_FORM_NAME, data);
  };

  useEffect(() => {
    if (!existedFormValue) {
      form.setFieldValue(PROCESSING_TIME_FORM_NAME, initialValue);
    }
  }, []);

  return (
    <EddLayout left={(
      <FormContentLayout
        title={PROCESSING_TIME_TITLE}
        description={PROCESSING_TIME_DESCRIPTION}
        step={EddSteps.FIRST}
      >
        <div className={styles.input}>
          <Select
            className={styles.autocomplete}
            options={selectOptions}
            value={value}
            onChange={handleValueChange}
          />
          <div className={styles.text}>business days after order is placed</div>
        </div>
        <ButtonPair step={EddSteps.FIRST} disableNext={!value} />
      </FormContentLayout>
    )}
    />
  );
};

export { ProcessingTime };
